import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IAddProSeatsInfo } from './interfaces';
import { addProSeats, previewAddProSeats } from './thunk';

const initialState: IAddProSeatsInfo = {
  loading: false,
  amountDue: null,
  total: null,
  currency: null,
  error: null,
  isPreview: null
};

const addProSeatsSlice = createSlice({
  name: 'addProSeats',
  initialState,
  reducers: {},
  extraReducers: {
    [previewAddProSeats.pending.type]: (state: IAddProSeatsInfo): void => {
      state.loading = true;
      state.error = null;
      state.isPreview = true;
    },
    [previewAddProSeats.rejected.type]: (state: IAddProSeatsInfo, action: PayloadAction<string>): void => {
      state.loading = false;
      state.error = action.payload;
      state.isPreview = true;
    },
    [previewAddProSeats.fulfilled.type]: (state: IAddProSeatsInfo, action: PayloadAction<IAddProSeatsInfo>): void => {
      state.loading = false;
      state.error = null;
      state.amountDue = action.payload.amountDue;
      state.currency = action.payload.currency;
      state.total = action.payload.total;
      state.isPreview = true;
    },
    [addProSeats.pending.type]: (state: IAddProSeatsInfo): void => {
      state.loading = true;
      state.error = null;
      state.isPreview = false;
    },
    [addProSeats.rejected.type]: (state: IAddProSeatsInfo, action: PayloadAction<string>): void => {
      state.loading = false;
      state.error = action.payload;
      state.isPreview = false;
    },
    [addProSeats.fulfilled.type]: (state: IAddProSeatsInfo, action: PayloadAction<IAddProSeatsInfo>): void => {
      state.loading = false;
      state.error = null;
      state.amountDue = action.payload.amountDue;
      state.currency = action.payload.currency;
      state.total = action.payload.total;
      state.isPreview = false;
    }
  }
});

export const AddProSeatsReducer = addProSeatsSlice.reducer;